module.exports = __webpack_public_path__ + "img/1920_icon_waiting_circle.0112f496.svg";